/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IArticle } from '../../actions/DataServiceEntities.g';
import ArticleCollectionCard from '../lobas-article-collection/components/articleCollectionCard';
import { ILobasArticleCollectionMiniData } from './lobas-article-collection-mini.data';
import {
    ILobasArticleCollectionMiniProps,
    ILobasArticleCollectionMiniResources
} from './lobas-article-collection-mini.props.autogenerated';
import classNames from 'classnames';
export interface ILobasArticleCollectionMiniViewProps extends ILobasArticleCollectionMiniProps<ILobasArticleCollectionMiniData> {
    article: IArticle;
    resources: ILobasArticleCollectionMiniResources;
    locale: string;
}

/**
 *
 * LobasArticleCollection component
 * @extends {React.PureComponent<ILobasArticleCollectionMiniProps<ILobasArticleCollectionMiniData>>}
 */
class LobasArticleCollection extends React.PureComponent<ILobasArticleCollectionMiniProps<ILobasArticleCollectionMiniData>> {
    public constructor(props: ILobasArticleCollectionMiniProps<ILobasArticleCollectionMiniData>) {
        super(props);
        this.state = { articles: [] };
    }

    public componentDidMount() {
        console.log(this.props.data.articles);
        void this.props.data.articles.then(res => {
            this.setState({ articles: res.articles });
        });
    }

    public render(): JSX.Element | null {
        const itemsPerPage = this.props.config.itemsPerPage || 1;

        if (this.props.data.articles.status === 'FAILED') {
            return <div>{this.props.resources.noArticlesLabel}</div>;
        } else {
            var articles = this.state['articles'];

            var filteredArticles = articles.filter((a: IArticle) => {
                if (a.FilterKeywords && this.props.config.filterByTags) {
                    const keywords = a.FilterKeywords.split(',').map(k => k.trim());
                    return this.props.config.filterByTags.every(k => keywords.includes(k));
                } else {
                    if (this.props.config.filterByTags) {
                        return false;
                    } else {
                        return true;
                    }
                }
            });

            var slicedArticles = filteredArticles.slice(0, itemsPerPage);

            return (
                <div className={classNames(this.props.config.className, 'articleCollectionMini')}>
                    {slicedArticles.map((a: IArticle) => {
                        const articleCollectionViewProps = {
                            article: a,
                            resources: this.props.resources,
                            locale: this.props.context.request.locale
                        } as ILobasArticleCollectionMiniViewProps;
                        return (
                            // eslint-disable-next-line react/jsx-key, react/jsx-no-target-blank
                            <a
                                href={`${this.props.context.request.url.requestUrl.origin}${this.props.config.articlePageURL}/${a.URL}`}
                                target={this.props.config.openArticlesInNewTab ? '_blank' : undefined}
                            >
                                <ArticleCollectionCard {...articleCollectionViewProps}></ArticleCollectionCard>
                            </a>
                        );
                    })}
                </div>
            );
        }
    }
}

export default LobasArticleCollection;
